import {
  WHOLESALER_ADD_FAILURE,
  WHOLESALER_ADD_REQUEST,
  WHOLESALER_ADD_SUCCESS,
  WHOLESALER_EDIT_REQUEST,
  WHOLESALER_EDIT_SUCCESS,
  WHOLESALER_EDIT_FAILURE,
  WHOLESALER_VIEW_REQUEST,
  WHOLESALER_VIEW_SUCCESS,
  WHOLESALER_VIEW_FAILURE,
  WHOLESALER_VIEW_ALL_REQUEST,
  WHOLESALER_VIEW_ALL_SUCCESS,
  WHOLESALER_VIEW_ALL_FAILURE,
  WHOLESALER_DELETE_REQUEST,
  WHOLESALER_DELETE_SUCCESS,
  WHOLESALER_DELETE_FAILURE,
  WHOLESALER_RESET_STATE,
  WHOLESALER_SEARCH_REQUEST,
  WHOLESALER_SEARCH_SUCCESS,
  WHOLESALER_SEARCH_FAILURE,
} from "./WholesalerTypes";

// Add Wholesaler
export const wholesalerAddRequest = (credentials) => ({
  type: WHOLESALER_ADD_REQUEST,
  payload: credentials,
});

export const wholesalerAddSuccess = (product) => ({
  type: WHOLESALER_ADD_SUCCESS,
  payload: product,
});

export const wholesalerAddFailure = (error) => ({
  type: WHOLESALER_ADD_FAILURE,
  payload: error,
});

// Edit Wholesaler
export const wholesalerEditRequest = (id, updatedData) => ({
  type: WHOLESALER_EDIT_REQUEST,
  payload: { id, updatedData },
});

export const wholesalerEditSuccess = (updatedProduct) => ({
  type: WHOLESALER_EDIT_SUCCESS,
  payload: updatedProduct,
});

export const wholesalerEditFailure = (error) => ({
  type: WHOLESALER_EDIT_FAILURE,
  payload: error,
});

// View Wholesaler (Single)
export const wholesalerViewRequest = (id) => ({
  type: WHOLESALER_VIEW_REQUEST,
  payload: id,
});

export const wholesalerViewSuccess = (product) => ({
  type: WHOLESALER_VIEW_SUCCESS,
  payload: product,
});

export const wholesalerViewFailure = (error) => ({
  type: WHOLESALER_VIEW_FAILURE,
  payload: error,
});

// View All Wholesalers
export const wholesalerViewAllRequest = (payload) => ({
  type: WHOLESALER_VIEW_ALL_REQUEST,
  payload,
});

export const wholesalerViewAllSuccess = (products) => ({
  type: WHOLESALER_VIEW_ALL_SUCCESS,
  payload: products,
});

export const wholesalerViewAllFailure = (error) => ({
  type: WHOLESALER_VIEW_ALL_FAILURE,
  payload: error,
});

// View All Search Wholesaler Actions
export const wholesalerSearchViewAllRequest = () => ({
  type: WHOLESALER_SEARCH_REQUEST,
});

export const wholesalerSearchViewAllSuccess = (products) => ({
  type: WHOLESALER_SEARCH_SUCCESS,
  payload: products,
});

export const wholesalerSearchViewAllFailure = (error) => ({
  type: WHOLESALER_SEARCH_FAILURE,
  payload: error,
});

// Delete Wholesaler
export const wholesalerDeleteRequest = (id) => ({
  type: WHOLESALER_DELETE_REQUEST,
  payload: id,
});

export const wholesalerDeleteSuccess = (id) => ({
  type: WHOLESALER_DELETE_SUCCESS,
  payload: id,
});

export const wholesalerDeleteFailure = (error) => ({
  type: WHOLESALER_DELETE_FAILURE,
  payload: error,
});

//Reset Wholesaler
export const wholesalerResetState = () => ({
  type: WHOLESALER_RESET_STATE,
});
